/**
 * Common CPT (Current Procedural Terminology) Codes
 * Source: AMA CPT Code Set (subset of commonly used codes)
 */

const cptCodes = [
  // Office Visits - New Patient
  { code: '99201', description: 'Office visit, new patient, Level 1 (Minimal)' },
  { code: '99202', description: 'Office visit, new patient, Level 2 (20 min)' },
  { code: '99203', description: 'Office visit, new patient, Level 3 (30 min)' },
  { code: '99204', description: 'Office visit, new patient, Level 4 (45 min)' },
  { code: '99205', description: 'Office visit, new patient, Level 5 (60 min)' },
  
  // Office Visits - Established Patient
  { code: '99211', description: 'Office visit, established patient, Level 1 (Minimal)' },
  { code: '99212', description: 'Office visit, established patient, Level 2 (10 min)' },
  { code: '99213', description: 'Office visit, established patient, Level 3 (15 min)' },
  { code: '99214', description: 'Office visit, established patient, Level 4 (25 min)' },
  { code: '99215', description: 'Office visit, established patient, Level 5 (40 min)' },
  
  // Preventive Medicine - New Patient
  { code: '99381', description: 'Initial comprehensive preventive medicine, infant (under 1 year)' },
  { code: '99382', description: 'Initial comprehensive preventive medicine, ages 1-4' },
  { code: '99383', description: 'Initial comprehensive preventive medicine, ages 5-11' },
  { code: '99384', description: 'Initial comprehensive preventive medicine, ages 12-17' },
  { code: '99385', description: 'Initial comprehensive preventive medicine, ages 18-39' },
  { code: '99386', description: 'Initial comprehensive preventive medicine, ages 40-64' },
  { code: '99387', description: 'Initial comprehensive preventive medicine, 65 years and older' },
  
  // Preventive Medicine - Established Patient
  { code: '99391', description: 'Periodic comprehensive preventive medicine, infant (under 1 year)' },
  { code: '99392', description: 'Periodic comprehensive preventive medicine, ages 1-4' },
  { code: '99393', description: 'Periodic comprehensive preventive medicine, ages 5-11' },
  { code: '99394', description: 'Periodic comprehensive preventive medicine, ages 12-17' },
  { code: '99395', description: 'Periodic comprehensive preventive medicine, ages 18-39' },
  { code: '99396', description: 'Periodic comprehensive preventive medicine, ages 40-64' },
  { code: '99397', description: 'Periodic comprehensive preventive medicine, 65 years and older' },
  
  // Laboratory
  { code: '80053', description: 'Comprehensive metabolic panel' },
  { code: '80061', description: 'Lipid panel' },
  { code: '82947', description: 'Glucose; quantitative, blood' },
  { code: '83036', description: 'Hemoglobin; glycosylated (A1C)' },
  { code: '85025', description: 'Complete blood count (CBC) with differential' },
  { code: '85027', description: 'Complete blood count (CBC)' },
  { code: '84443', description: 'Thyroid stimulating hormone (TSH)' },
  { code: '84439', description: 'Thyroxine; total (T4)' },
  { code: '82306', description: 'Vitamin D, 25 hydroxy' },
  { code: '82565', description: 'Creatinine; blood' },
  { code: '84132', description: 'Potassium; serum' },
  { code: '84295', description: 'Sodium; serum' },
  
  // Immunizations
  { code: '90471', description: 'Immunization administration, 1 vaccine' },
  { code: '90472', description: 'Immunization administration, each additional vaccine' },
  { code: '90686', description: 'Influenza vaccine, quadrivalent' },
  { code: '90670', description: 'Pneumococcal conjugate vaccine' },
  { code: '90707', description: 'MMR vaccine' },
  { code: '90746', description: 'Hepatitis B vaccine, adult dosage' },
  { code: '90732', description: 'Pneumococcal polysaccharide vaccine, 23-valent' },
  { code: '90714', description: 'Tetanus and diphtheria toxoids (Td)' },
  { code: '90715', description: 'Tetanus, diphtheria toxoids and acellular pertussis (Tdap)' },
  { code: '90750', description: 'Zoster (shingles) vaccine, live' },
  { code: '91303', description: 'Zoster (shingles) vaccine, recombinant' },
  
  // Procedures
  { code: '11200', description: 'Removal of skin tags, 1-15 lesions' },
  { code: '17000', description: 'Destruction of benign or premalignant lesions, first lesion' },
  { code: '17110', description: 'Destruction of flat warts, molluscum contagiosum, 1-14 lesions' },
  { code: '36415', description: 'Routine venipuncture for collection of specimen' },
  { code: '93000', description: 'Electrocardiogram (ECG), complete' },
  { code: '93005', description: 'Electrocardiogram (ECG), tracing only' },
  { code: '94060', description: 'Spirometry, bronchodilation responsiveness' },
  { code: '94640', description: 'Pressurized or nonpressurized inhalation treatment for airway obstruction' },
  
  // Radiology
  { code: '71045', description: 'Chest X-ray, single view' },
  { code: '71046', description: 'Chest X-ray, 2 views' },
  { code: '73610', description: 'Ankle X-ray, complete, minimum 3 views' },
  { code: '73630', description: 'Foot X-ray, complete, minimum 3 views' },
  { code: '70450', description: 'CT head/brain without contrast' },
  { code: '70553', description: 'MRI brain without and with contrast' },
  { code: '72148', description: 'MRI lumbar spine without contrast' },
  { code: '76700', description: 'Ultrasound, abdominal, complete' },
  { code: '76856', description: 'Ultrasound, pelvic (nonobstetric), complete' },
  { code: '77080', description: 'DXA bone density study, 1 or more sites' },
  
  // Screening/Diagnostic
  { code: '81001', description: 'Urinalysis, automated, with microscopy' },
  { code: '81003', description: 'Urinalysis, automated, without microscopy' },
  { code: '82270', description: 'Occult blood, feces, qualitative' },
  { code: '87081', description: 'Culture, bacterial, aerobic, screening only' },
  { code: '87086', description: 'Urine culture, bacterial, quantitative' },
  { code: '87880', description: 'Infectious agent antigen detection, Strep A, rapid' },
  { code: '87804', description: 'Influenza virus, rapid' },
  { code: '87635', description: 'SARS-CoV-2 (COVID-19), amplified probe technique' },
  { code: '86580', description: 'TB skin test (PPD), intradermal' },
  { code: '86701', description: 'HIV-1 and HIV-2 antibody screen' },
  
  // Cardiovascular
  { code: '93306', description: 'Echocardiography, transthoracic, complete' },
  { code: '93015', description: 'Cardiovascular stress test' },
  { code: '93225', description: 'ECG monitoring, 24 hours' },
  { code: '93320', description: 'Doppler echocardiography, pulsed wave and/or continuous wave' },
  
  // Injection/Infusion
  { code: '96372', description: 'Therapeutic injection, subcutaneous or intramuscular' },
  { code: '96365', description: 'Intravenous infusion, initial, up to 1 hour' },
  { code: '96366', description: 'Intravenous infusion, each additional hour' },
  { code: '96374', description: 'Therapeutic injection, intravenous push, single or initial' },
  
  // Other Common
  { code: '99000', description: 'Specimen handling' },
  { code: '99070', description: 'Supplies and materials' },
  { code: '99091', description: 'Collection and interpretation of patient data, 30 minutes' },
  { code: '99453', description: 'Remote monitoring, initial setup' },
  { code: '99454', description: 'Remote monitoring device supply, first 30 days' },
];

export function searchCPTCodes(query) {
  if (!query || query.length < 2) return [];
  
  const searchTerm = query.toLowerCase();
  return cptCodes.filter(cpt => 
    cpt.code.toLowerCase().includes(searchTerm) || 
    cpt.description.toLowerCase().includes(searchTerm)
  ).slice(0, 50); // Limit results
}

export default cptCodes;
